import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { AiFillPlayCircle } from "react-icons/ai";
import LandingPageHeaderTwo from "../LandingPageHeaderTwo/LandingPageHeaderTwo";
import headerBackground from "../../../assets/staticAssets/headerBackground.png";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import LandingPageNavbar from "../../LandingPageNavbar";

function LandingPageHeader() {
  const classes = useStyles();
  const history = useHistory();
  const token = useSelector((state) => state.trading.TOKEN);

  return (
    <div className="  hero-landing ">
      {/* <LandingPageNavbar></LandingPageNavbar> */}
      <LandingPageHeaderTwo />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  mainColor: {
    color: "#3AC4AB",
  },
  headerBackground: {
    position: "absolute",
    width: "90vw",
    right: "0",
    top: "-10%",
    height: "80vh",
    // height: "575px",
    zIndex: "-200",
  },
  mainGrid: {
    height: "100%",
  },
  gridLeft: {
    display: "flex",
    alignItems: "center",
  },
  gridRight: {
    height: "100%",
    width: "100%",
  },

  button: {
    background: "#3AC4AB",
    textTransform: "capitalize",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "160px",
    height: "3.2rem",
    cursor: "pointer",
    zIndex: "2",
  },
  icon: {
    fontSize: "2rem",
  },
  imageHolder: {
    position: "relative",
    height: "100%",
  },
  gridRightImage: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translateX(20%)",
    height: "auto",
    maxWidth: "",
  },
}));

export default LandingPageHeader;
